export const PENDING_STATUS = 'pending_status'
export const SENT_STATUS = 'sent_status'
export const DELIVERED_STATUS = 'delivered_status'
export const READ_STATUS = 'read_status'
export const ERROR_STATUS = 'error_status'

export const STATUS_MAP = Object.freeze({
  pending: PENDING_STATUS,

  sentAPI: SENT_STATUS,
  accepted: SENT_STATUS,
  scheduled: SENT_STATUS,
  queued: SENT_STATUS,
  sending: SENT_STATUS,
  sent: SENT_STATUS,

  delivered: DELIVERED_STATUS,
  read: READ_STATUS,

  undelivered: ERROR_STATUS,
  error: ERROR_STATUS,
  failed: ERROR_STATUS,
  canceled: ERROR_STATUS,
})

export const ERROR_STATUS_LIST = [
  'undelivered',
  'error',
  'failed',
  'canceled',
]

export const CHANNELS_WITH_STATUS = [
  'whatsapp_whatsapp'
]